@if (logs.length) {
  <table class="logs">
    <thead>
      <tr>
        <th>Status Date</th>
        <th>Status By</th>
        <th>Status</th>
        <th>Status Message</th>
      </tr>
    </thead>
    <tbody>
      @for (log of logs; track index; let index = $index) {
        <tr>
          <td>{{ log.changed | dateTimeFormat }}</td>
          <td>
            <div [appEllipsisTooltip]="log.changedBy">{{ log.changedBy }}</div>
          </td>
          <td>{{ log.status }}</td>
          <td>
            <div [appEllipsisTooltip]="log.message | stripHtml">{{ log.message | stripHtml }}</div>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
